// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./metadata/font/corleone.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./metadata/font/corleoneDue.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./metadata/font/hardsignLayered.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./metadata/font/heidardemoRegular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'corleone';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: 'corleoneDue';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: 'hardsign';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: 'heird';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

:root {
  --background: rgba(28, 27, 23, 1.0);
  --backgroundTranslucent: rgba(28, 27, 23, 0.69);
  --text: rgba(255, 255, 255, 1.0);
  --primary: rgba(235, 174, 94, 1.0);
  --primaryTranslucent: rgba(235, 174, 94, 0.69);
  --secondary: rgba(133,76,21, 1.0);
  --secondaryTranslucent: rgba(133,76,21, 0.8);
  --accent: rgba(190, 35, 21, 1.0);
  --accentTranslucent: rgba(190, 35, 21, 0.69);
}

.goldText {
  color: var(--primary) !important;
}

html {
  height: 100%;
}
body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;

  font-family: 'hardsign';
  background-color: var(--background);
  color: var(--text);

  overflow: hidden;
}

#landingPage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
#closeLandingBtn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
  font-size: 1.6rem;
  font-family: 'hardsign';
  letter-spacing: 3px;
  color: var(--text);
  background-color: var(--background);
  padding: 8px 16px;
  border: 3px solid var(--primary);
  cursor: pointer;
}


#mainPage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 16px;
}

#mainPage header {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#mainPage header span {
  margin: 0;
  font-size: 4rem;
  letter-spacing: 2px;
  line-height: 3.5rem;
  text-align: center;
}


#mainPage main {
  width: 100%;
  height: calc(100% - 170px);
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 96px;
}

#fbdMainImg {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -24px;
  border: 3px solid var(--primary);
  padding: 16px;
  background-color: var(--background);
}

#socials {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
#socials button {
  font-family: 'hardsign';
  font-size: 1.5rem;
  letter-spacing: 3px;
  color: var(--text);
  background-color: var(--background);
  padding: 8px 16px;
  border: 3px solid var(--primary);
}
#buyBtn {
  color: var(--text) !important;
  background-color: rgba(34, 44, 44, 1.0) !important;
  border: 3px solid rgba(115, 139, 140, 1.0) !important;
}


#mainPage footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

#contractContainer {
  width: 100%;
  display: flex; 
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background-color: var(--background);
  border: 3px solid var(--primary);
}
#contractContainer span {
  font-size: 1.4rem;
  letter-spacing: 2px;
  white-space: nowrap;
}
#contractContainer button {
  font-family: 'hardsign';
  font-size: 1.5rem;
  letter-spacing: 3px;
  white-space: nowrap;

  background-color: var(--background);
  border: none;
  color: var(--primary);
  cursor: pointer;
}


@media screen and (max-width: 736px) {
  
  #closeLandingBtn {
    font-size: 1.2rem;
  }


  #mainPage header {
    margin-top: 12px;
    white-space: wrap;
  }
  #mainPage header span {
    margin: 0;
    font-size: 3rem;
  }


  #mainPage main {
    height: calc(100% - 200px);
    margin-top: 125px;
  }

  #fbdMainImg {
    width: 240px;
    margin-top: -64px;
    border: 3px solid var(--primary);
    padding: 12px;
  }


  #socials {
    margin-bottom: 12px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 12px; 
  }
  #socials button {
    font-size: 1.4rem;
    letter-spacing: 2px;
    padding: 6px 12px;
  }


  #contractContainer {
    gap: 12px;
    padding: 12px;
    justify-content: center;
  }
  #contractContainer span {
    font-size: 1rem;
    white-space: wrap;
    word-break: break-all;
    text-align: start;
  }
  #contractContainer button {
    font-size: 1.4rem;
    letter-spacing: 2px;
  }

}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4CAAwC;AAC1C;AACA;EACE,0BAA0B;EAC1B,4CAA2C;AAC7C;AACA;EACE,uBAAuB;EACvB,4CAA+C;AACjD;AACA;EACE,oBAAoB;EACpB,4CAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;EAC/C,gCAAgC;EAChC,kCAAkC;EAClC,8CAA8C;EAC9C,iCAAiC;EACjC,4CAA4C;EAC5C,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,SAAS;;EAET,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,kDAAkD;EAClD,qDAAqD;AACvD;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mCAAmC;EACnC,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;;EAEnB,mCAAmC;EACnC,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;;AAGA;;EAEE;IACE,iBAAiB;EACnB;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,eAAe;EACjB;;;EAGA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;EACf;;;EAGA;IACE,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;EACnB;;;EAGA;IACE,SAAS;IACT,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;AAEF","sourcesContent":["@font-face {\n  font-family: 'corleone';\n  src: url('./metadata/font/corleone.ttf');\n}\n@font-face {\n  font-family: 'corleoneDue';\n  src: url('./metadata/font/corleoneDue.ttf');\n}\n@font-face {\n  font-family: 'hardsign';\n  src: url('./metadata/font/hardsignLayered.ttf');\n}\n@font-face {\n  font-family: 'heird';\n  src: url('./metadata/font/heidardemoRegular.otf');\n}\n\n:root {\n  --background: rgba(28, 27, 23, 1.0);\n  --backgroundTranslucent: rgba(28, 27, 23, 0.69);\n  --text: rgba(255, 255, 255, 1.0);\n  --primary: rgba(235, 174, 94, 1.0);\n  --primaryTranslucent: rgba(235, 174, 94, 0.69);\n  --secondary: rgba(133,76,21, 1.0);\n  --secondaryTranslucent: rgba(133,76,21, 0.8);\n  --accent: rgba(190, 35, 21, 1.0);\n  --accentTranslucent: rgba(190, 35, 21, 0.69);\n}\n\n.goldText {\n  color: var(--primary) !important;\n}\n\nhtml {\n  height: 100%;\n}\nbody {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n\n  font-family: 'hardsign';\n  background-color: var(--background);\n  color: var(--text);\n\n  overflow: hidden;\n}\n\n#landingPage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n#closeLandingBtn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  white-space: nowrap;\n  font-size: 1.6rem;\n  font-family: 'hardsign';\n  letter-spacing: 3px;\n  color: var(--text);\n  background-color: var(--background);\n  padding: 8px 16px;\n  border: 3px solid var(--primary);\n  cursor: pointer;\n}\n\n\n#mainPage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 16px;\n}\n\n#mainPage header {\n  width: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n#mainPage header span {\n  margin: 0;\n  font-size: 4rem;\n  letter-spacing: 2px;\n  line-height: 3.5rem;\n  text-align: center;\n}\n\n\n#mainPage main {\n  width: 100%;\n  height: calc(100% - 170px);\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin-top: 96px;\n}\n\n#fbdMainImg {\n  width: 400px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin-top: -24px;\n  border: 3px solid var(--primary);\n  padding: 16px;\n  background-color: var(--background);\n}\n\n#socials {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n#socials button {\n  font-family: 'hardsign';\n  font-size: 1.5rem;\n  letter-spacing: 3px;\n  color: var(--text);\n  background-color: var(--background);\n  padding: 8px 16px;\n  border: 3px solid var(--primary);\n}\n#buyBtn {\n  color: var(--text) !important;\n  background-color: rgba(34, 44, 44, 1.0) !important;\n  border: 3px solid rgba(115, 139, 140, 1.0) !important;\n}\n\n\n#mainPage footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n#contractContainer {\n  width: 100%;\n  display: flex; \n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  background-color: var(--background);\n  border: 3px solid var(--primary);\n}\n#contractContainer span {\n  font-size: 1.4rem;\n  letter-spacing: 2px;\n  white-space: nowrap;\n}\n#contractContainer button {\n  font-family: 'hardsign';\n  font-size: 1.5rem;\n  letter-spacing: 3px;\n  white-space: nowrap;\n\n  background-color: var(--background);\n  border: none;\n  color: var(--primary);\n  cursor: pointer;\n}\n\n\n@media screen and (max-width: 736px) {\n  \n  #closeLandingBtn {\n    font-size: 1.2rem;\n  }\n\n\n  #mainPage header {\n    margin-top: 12px;\n    white-space: wrap;\n  }\n  #mainPage header span {\n    margin: 0;\n    font-size: 3rem;\n  }\n\n\n  #mainPage main {\n    height: calc(100% - 200px);\n    margin-top: 125px;\n  }\n\n  #fbdMainImg {\n    width: 240px;\n    margin-top: -64px;\n    border: 3px solid var(--primary);\n    padding: 12px;\n  }\n\n\n  #socials {\n    margin-bottom: 12px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    grid-column-gap: 12px;\n    grid-row-gap: 12px; \n  }\n  #socials button {\n    font-size: 1.4rem;\n    letter-spacing: 2px;\n    padding: 6px 12px;\n  }\n\n\n  #contractContainer {\n    gap: 12px;\n    padding: 12px;\n    justify-content: center;\n  }\n  #contractContainer span {\n    font-size: 1rem;\n    white-space: wrap;\n    word-break: break-all;\n    text-align: start;\n  }\n  #contractContainer button {\n    font-size: 1.4rem;\n    letter-spacing: 2px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
